import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import marketingSmall from '@icons/marketingSmall';
import salesSmall from '@icons/salesSmall';
import salesIntSmall from '@icons/salesIntSmall';
import webVisitorSmall from '@icons/webVisitorSmall';
import b2bAddSmall from '@icons/b2bAddSmall';
import Capabilities from '../../ctas/Capabilities';
import PlaybooksCTA from '../../ctas/Playbooks';

export const Solutions = () => {
  const { t } = useTranslation();
  return {
    label: t('nav_label_use_cases'),
    submenus: [
      {
        label: t('nav_by_team'),
        columns: 1,
        subgroups: [
          {
            label: t('nav_solutions_marketing'),
            href: '/solutions/marketing',
            caption: t('nav_solutions_marketing_caption'),
            icon: marketingSmall,
            grid: true,
          },
          {
            label: t('nav_solutions_sales'),
            href: '/solutions/sales',
            caption: t('nav_solutions_sales_caption'),
            icon: salesSmall,
            grid: true,
          },
        ],
      },
      {
        label: t('nav_by_use'),
        columns: 2,
        subgroups: [ 
          {
            label: 'Sales Intelligence',
            href: '/solutions/sales-prospecting',
            caption: t('nav_label_sales_prospecting_page'),
            icon: salesIntSmall,
            grid: true,
          },
          {
            label: t('nav_sales_advertising_page'),
            href: '/solutions/b2b-advertising',
            caption: t('nav_sales_advertising_page_caption'),
            icon: b2bAddSmall,
            grid: true,
          },
          {
            label: 'Web Visitor Identification',
            href: '/solutions/web-visitor-tracking',
            caption: t('nav_webvisitors_ident_caption'),
            icon: webVisitorSmall,
            grid: true,
          },
        ],
      },
    ],
    ctas: [
      { label: 'Capabilities', content: <Capabilities newCap={true} /> },
      { columns: 1, label: 'Playbooks', content: <PlaybooksCTA limit={3} featured={false} /> }
    ],
  };
};
